import React, { useState } from "react";

// Soft animated bokeh particles. Lightweight CSS only — no JS animation loop.
const PALETTE = [
  "rgba(255, 46, 147, 0.55)",
  "rgba(24, 211, 255, 0.55)",
  "rgba(255, 255, 255, 0.35)",
  "rgba(184, 32, 255, 0.45)",
];

const buildParticles = (count) =>
  Array.from({ length: count }).map((_, i) => ({
    id: i,
    size: 40 + Math.random() * 140,
    left: `${Math.random() * 100}%`,
    top: `${60 + Math.random() * 50}%`,
    color: PALETTE[i % PALETTE.length],
    duration: 14 + Math.random() * 16,
    delay: -Math.random() * 20,
    scale: 0.6 + Math.random() * 0.9,
  }));

export const BokehParticles = ({ count = 14, className = "" }) => {
  const [particles] = useState(() => buildParticles(count));

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden>
      {particles.map((p) => (
        <span
          key={p.id}
          className="bokeh"
          style={{
            width: p.size,
            height: p.size,
            left: p.left,
            top: p.top,
            background: `radial-gradient(circle at center, ${p.color} 0%, transparent 70%)`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            transform: `scale(${p.scale})`,
          }}
        />
      ))}
    </div>
  );
};

export default BokehParticles;
